import React, { FC, useEffect } from 'react';
import { useForm } from 'react-hook-form';
import useKeyPress from '../../hooks/useKeyPress';
import { RequireAtLeastOne } from '../../types';
import { ALPHABETS } from '../../utils';
import FormContainer, { PreviousPage } from '../Shared/FormContainer/FormContainer';
import { Accessibility, ChoiceContainer, FormChoiceButton, FormChoiceButtons, FormChoiceWrapper, FormLabel } from './styled';
import { BUTTON_TYPES, FORM_CHOICE_COMPONENT_TYPES } from './types';

interface FormChoiceProps {
  type?: keyof typeof FORM_CHOICE_COMPONENT_TYPES;
  formOptions: ReturnType<typeof useForm>;
  title?: string;
  loading?: boolean;
  previousPage?: PreviousPage;
  defaultValue?: string;
  componentItems?: { title: string; options: { option: string; value: string; buttonType?: BUTTON_TYPES }[]; registerAs: string };
}
const FormChoice: FC<RequireAtLeastOne<FormChoiceProps, 'type' | 'componentItems'>> = ({ type, formOptions, title, loading, previousPage, defaultValue, componentItems }) => {
  const { title: defaultTitle, options, registerAs } = componentItems || FORM_CHOICE_COMPONENT_TYPES[type!];
  const { register, setValue } = formOptions;

  const keys = useKeyPress(ALPHABETS.slice(0, options.length));

  useEffect(() => {
    if (keys) {
      const index = ALPHABETS.findIndex(alphabet => keys[alphabet]);
      if (index !== -1) {
        setValue(`choice_${registerAs}`, options[index].value);
      }
    }
  }, [keys]);

  return (
    <FormChoiceWrapper>
      <FormContainer title={title || defaultTitle} noNextButton loadingData={loading} previousPage={previousPage}>
        <FormChoiceButtons disabled={loading}>
          {options.map((option, index) => (
            <ChoiceContainer key={index}>
              <FormLabel>
                <input
                  type="radio"
                  {...register(`choice_${registerAs}`, {
                    validate: () => loading
                  })}
                  value={option.value}
                />
                <FormChoiceButton buttonType={option?.buttonType || BUTTON_TYPES.NORMAL} pressed={keys[ALPHABETS[index]]} disabled={loading} isDefault={defaultValue === option.value}>
                  <span>{option.option}</span>
                </FormChoiceButton>
              </FormLabel>
              <Accessibility>
                or Press<span> {ALPHABETS[index]}</span>
              </Accessibility>
            </ChoiceContainer>
          ))}
        </FormChoiceButtons>
      </FormContainer>
    </FormChoiceWrapper>
  );
};

export default FormChoice;
